<template>
  <gmap-autocomplete
    class="gmap-autocomplete"
    @place_changed="updateCurrentPlace"
    :select-first-on-enter="true"
    :placeholder="t('globalMapSearchPlaceholder')"
    :options="{
      fields: ['geometry'],
      sessionToken: sessionToken,
    }"

    >
  </gmap-autocomplete>
</template>

<script>
import { mapActions } from 'vuex';
import { translationMixin } from '@/mixins/translationMixin';

export default {
  name: 'GlobalMapSerchAutoComplet',
  mixins: [translationMixin],
  data() {
    return { sessionToken: null };
  },
  mounted() {
    this.$gmapApiPromiseLazy().then(() => {
      this.sessionToken = new google.maps.places.AutocompleteSessionToken();
    });
  },
  methods:
  {
    ...mapActions([ 'setOneMarker',
                    ]),
    updateCurrentPlace (place) {
      if ( place.geometry ){
        this.setOneMarker( {  latPoint: place.geometry.location.lat(),
                              lngPoint: place.geometry.location.lng(),
                              name: this.t('globalMapSearchNewAttractionMarkerName')} )
        this.$emit("handleserchPointChange", place);
        this.sessionToken = new google.maps.places.AutocompleteSessionToken();
      }
   },
  },
};
</script>
